import React from "react";
import {
  Box,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

// The identity details (entity / UIDs) are opt-in; every measure starts on.
export const TOGGLES = [
  { value: "est", label: "Estimate" },
  { value: "bud", label: "Budget" },
  { value: "act", label: "Actual" },
  { value: "inv", label: "Invoiced" },
  { value: "pd", label: "Paid" },
  { value: "details", label: "UID register" },
];
export const DEFAULT_VISIBLE = ["est", "bud", "act", "inv", "pd"];

/**
 * The table's own controls, drawn as its top bar: which column groups to show,
 * and the Enter data button (why it's disabled shows as its tooltip).
 */
export default function TableToolbar({
  visible,
  onVisibleChange,
  onEnterData,
  enterDisabled,
  enterDisabledReason,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1.5,
        px: 1.5,
        py: 1,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography variant="subtitle2" color="text.secondary">
        Columns
      </Typography>
      <ToggleButtonGroup
        size="small"
        color="primary"
        value={visible}
        onChange={(_event, next) => onVisibleChange(next)}
        aria-label="Columns"
      >
        {TOGGLES.map(({ value, label }) => (
          <ToggleButton key={value} value={value} sx={{ px: 1.25 }}>
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <Box sx={{ flex: 1 }} />
      <Tooltip title={enterDisabled ? enterDisabledReason : ""}>
        <span>
          <Button
            size="small"
            variant="contained"
            startIcon={<EditIcon fontSize="small" />}
            disabled={enterDisabled}
            onClick={onEnterData}
          >
            Enter data
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
}
